<template>
  <LoginForm />
</template>

<script setup>
import LoginForm from "@/components/User/LoginForm.vue";
</script>

<style scoped>
/* Estilos específicos para a view de login, se necessário */
</style>
